import React from 'react';
import { Box, Button, Tooltip } from '@mui/material';
import { format } from 'date-fns';
import StatusChip from '@shared/components/StatusChip/StatusChip';
import { OfferScheduleDTO } from '../../types';

interface ScheduleButtonsProps {
  scheduleDraft?: OfferScheduleDTO;
  startDate?: string;
  endDate?: string;
  onScheduleClick: () => void;
  onPromotionClick: () => void;
}

export const ScheduleButtons: React.FC<ScheduleButtonsProps> = ({
  scheduleDraft,
  startDate,
  endDate,
  onScheduleClick,
  onPromotionClick,
}) => {
  const hasDateRange = startDate && endDate;

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'right',
        gap: 1,
      }}
    >
      {scheduleDraft?.start_date && scheduleDraft?.end_date && (
        <StatusChip
          label={`From ${format(new Date(scheduleDraft.start_date), 'dd MMM yyyy, hh:mm a')} to ${format(
            new Date(scheduleDraft.end_date),
            'dd MMM yyyy, hh:mm a',
          )}`}
          status={'default'}
          variant="outlined"
        />
      )}
      <Tooltip title={!hasDateRange ? 'Please select start and end dates first' : ''} arrow>
        <span>
          <Button
            variant="outlined"
            size="small"
            sx={{ ml: 1 }}
            onClick={onScheduleClick}
            disabled={!hasDateRange}
          >
            Advanced Schedule
          </Button>
        </span>
      </Tooltip>
      <Box>
        <Button variant="outlined" size="small" onClick={onPromotionClick} disabled={!hasDateRange}>
          Configure Promotion
        </Button>
      </Box>
    </Box>
  );
};
